import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useDb from "./useDb";

const useAppointment = (_id) => {
  const [appointment, setAppointment] = useState(null);
  const history = useHistory();
  const db = useDb();

  useEffect(() => {
    db.appointments
      .get({ _id })
      .then((_appointment) => setAppointment(_appointment))
      .catch(() => history.push("/app"));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (appointment) {
      db.appointments.put(appointment);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointment]);

  return { appointment, setAppointment };
};

export default useAppointment;
